import React, { useState } from "react";
import "./Appointment.css";
import emailjs from "@emailjs/browser";

function Appointment() {
  const publicKey = process.env.REACT_APP_PUBLIC_KEY;
  const templateKey = process.env.REACT_APP_TEMPLATE_ID;
  const serviceKey = process.env.REACT_APP_SERVICE_ID;

  const [loading, setLoading] = useState(false);

  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    date: "",
    time: "",
    service: "",
    message: ""
  });

  const holidays = ["2026-01-01", "2026-04-20", "2026-05-01"];

  const isWeekday = (date) => {
    const day = new Date(date).getDay();
    return day >= 1 && day <= 5;
  };

  const isHoliday = (date) => holidays.includes(date);

  const isToday = (date) => {
    return date && new Date(date).toDateString() === new Date().toDateString();
  };

  // ⏰ подобрен time slots
  const generateTimeSlots = (selectedDate) => {
    const slots = [];

    for (let hour = 12; hour < 15; hour++) {
      slots.push(`${hour}:00`);
      slots.push(`${hour}:30`);
    }
    slots.push("15:00");

    if (!selectedDate) return [];

    if (isToday(selectedDate)) {
      const now = new Date();
      const minTime = now.getHours() * 60 + now.getMinutes() + 120;

      return slots.filter((time) => {
        const [h, m] = time.split(":").map(Number);
        const slotTime = h * 60 + m;
        return slotTime >= minTime;
      });
    }

    return slots;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    // reset time ако се смени датум
    if (name === "date") {
      if (!isWeekday(value)) {
        alert("Не работиме за викенд");
        return;
      }

      if (isHoliday(value)) {
        alert("Празник - не работиме");
        return;
      }

      setForm({ ...form, date: value, time: "" });
      return;
    }

    setForm({ ...form, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!form.name || !form.email || !form.date || !form.time || !form.service) {
      alert("Пополнете ги сите задолжителни полиња");
      return;
    }

    setLoading(true);

    emailjs
      .send(
        serviceKey,
        templateKey,
        {
          name: form.name,
          email: form.email,
          phone: form.phone,
          date: form.date,
          time: form.time,
          service: form.service,
          message: form.message
        },
        publicKey
      )
      .then(() => {
        alert("Барањето за терминот е успешно испратено, наскоро ќе бидете контактирани од тимот на Лукс Медикус!");
        setForm({
          name: "",
          email: "",
          phone: "",
          date: "",
          time: "",
          service: "",
          message: ""
        });
      })
      .catch(() => {
        alert("Грешка при испраќање!");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <section id="appointment" className="appointment">
      <div className="container">

        <div className="appointment-header">
          <h2>Мој Термин</h2>
          <div className="line"></div>
          <p>Закажете термин лесно и брзо</p>
        </div>

        <form className="appointment-form" onSubmit={handleSubmit}>

          <input
            name="name"
            placeholder="Име и презиме"
            value={form.name}
            onChange={handleChange}
          />

          <input
            name="email"
            type="email"
            placeholder="Е-маил"
            value={form.email}
            onChange={handleChange}
          />

          <input
            name="phone"
            placeholder="Телефон"
            value={form.phone}
            onChange={handleChange}
          />

          <input
            name="date"
            type="date"
            min={new Date().toISOString().split("T")[0]}
            value={form.date}
            onChange={handleChange}
          />

          <select
            name="time"
            value={form.time}
            onChange={handleChange}
            disabled={!form.date}
          >
            <option value="">Избери саат</option>
            {generateTimeSlots(form.date).map((time) => (
              <option key={time}>{time}</option>
            ))}
          </select>

          <select
            name="service"
            value={form.service}
            onChange={handleChange}
          >
            <option value="">Избери услуга</option>
            <option>Лекарско уверение</option>
            <option>Систематски преглед</option>
            <option>Лабораторија</option>
          </select>
          
          <small className="service-note">
            * Не издаваме лекарски уверенија за возачка дозвола.
          </small>


          <textarea
            name="message"
            placeholder="Порака"
            value={form.message}
            onChange={handleChange}
          />

          <button type="submit" disabled={loading}>
            {loading ? "Се испраќа..." : "Закажи термин"}
          </button>

        </form>
      </div>
    </section>
  );
}

export default Appointment;